import {createAction} from '@reduxjs/toolkit'
import {TrackEventPayload} from '../types/Events'

export const TRACK_USER_ACTION = 'TRACK_USER_ACTION'
export const TRACK_ERROR_TRIGGERED = 'TRACK_ERROR_TRIGGERED'
export const TRACK_EXPERIMENT_SERVED = 'TRACK_EXPERIMENT_SERVED'

export interface TrackUserActionType {
  params: {
    action: string
    category: string
    label?: string
    meta?: Record<string, unknown>
  }
  type: string
}

export interface TrackErrorTriggeredEventType {
  errorMessage: unknown
  errorType: string
}

export interface TrackerErrorTriggeredActionType {
  event: TrackErrorTriggeredEventType
  type: string
}

// TODO: Typing based on Toggle Library
type ExperimentIdType = string
type VariationIdType = string

export interface TrackExperimentServedActionType {
  experimentId: ExperimentIdType
  isActive: boolean
  type: typeof TRACK_EXPERIMENT_SERVED
  variationId: VariationIdType
}

/**
 * @deprecated Use trackEvent
 */
export const trackUserAction = (
  action: string,
  category: string,
  label?: string,
  meta?: Record<string, unknown>
): TrackUserActionType => ({
  params: {action, category, label, meta},
  type: TRACK_USER_ACTION
})

/**
 * @deprecated Use trackEvent
 */
export const trackErrorTriggered = (
  event: TrackErrorTriggeredEventType
): TrackerErrorTriggeredActionType => ({
  event,
  type: TRACK_ERROR_TRIGGERED
})

/**
 * Returns the tracking action for an experiment being served
 * @param experimentId - the id of the experiment
 * @param variationId - the if of the experiment variation
 */
// TODO (@gabrielmanara) [2022-05-01]: Migrate to toolkit standard before finish the https://app.shortcut.com/findhotel/epic/41880/tracking-standardisation epic
export const trackExperimentServed = (
  experimentId: TrackExperimentServedActionType['experimentId'],
  variationId: TrackExperimentServedActionType['variationId']
): TrackExperimentServedActionType => ({
  experimentId,
  variationId,
  isActive: true,
  type: TRACK_EXPERIMENT_SERVED
})

export const trackEvent = createAction<TrackEventPayload>(
  'analytics/trackEvent'
)
